import { useState } from "react"
import { JobbinPrimaryButtonProps } from "./model"

export const JobbinPrimaryButton = (props: JobbinPrimaryButtonProps) => {
    const [pending, setPending] = useState(false)
    const busy = pending || props.loading
    const isDisabled = busy || props.disabled

    const handleClick = async () => {
        if (isDisabled || !props.onClickAction) return
        const result = props.onClickAction()
        if (result && typeof (result as Promise<void>).then === "function") {
            try {
                setPending(true)
                await result
            } finally {
                setPending(false)
            }
        }
    }

    return (
        <button
            type="button"
            onClick={handleClick}
            disabled={isDisabled}
            className="jobbin-primary-button flex w-full items-center justify-center gap-2 py-[16px] px-[32px] bg-figmaPrimary text-figmaWhite rounded-[12px] font-semibold text-[16px] transition active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-60 disabled:active:scale-100"
        >
            {busy && (
                <span className="h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent" />
            )}
            {props.text}
        </button>
    )
}